/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useAppSelector } from "../../../../../config/hooks";

export interface SummaryRef {
  getHtml: () => string;
  getFullHtml: () => string;
}

interface SummaryProps {
  content?: string;
  index: number;
  companyLogo?: string;
}

interface PricingItem {
  name: string;
  description?: string;
  services?: { name: string; description: string }[];
}

const ScopeOfWork = forwardRef<SummaryRef, SummaryProps>(
  ({ content = "", index, companyLogo }, ref) => {
    const quillRef = useRef<any>(null);
    const [scopeText, setScopeText] = useState<string>(content);

    const pricingData =
      (useAppSelector(
        (state) => state?.potentialDeal?.proposalBuilderData?.data?.pricing
      ) as PricingItem[]) || [];

    useImperativeHandle(ref, () => ({
      getHtml: () => {
        return `${scopeText}`;
      },
      getFullHtml: () => {
        return `<div class="summary_section">
        <div class="header">
          <div class="proposal_title main_title">
            <div class="page_counter"> 0${index} </div>
            <h4 style="margin-left: 24px;"> Scope </h4>
          </div>
          <div class="logo_container">
          ${
            companyLogo
              ? `<img src="${companyLogo}" class="temp_logo" alt="logo" />`
              : `<img src="/images/company/no_image_grey.png" class="temp_logo" alt="logo"/>`
          }
          </div>
        </div>
        <div class="content">
          ${scopeText}
        </div>
      </div>`;
      },
    }));

    useEffect(() => {
      const data = pricingData?.map((item, index) => {
        const sectionNumber = `${index + 1}`;
        return `
          <div>
            <h3>
              ${sectionNumber}. ${item.name.trim()}
            </h3>
            <p>${item?.description ?? ""}</p>
            ${
              item?.services && item?.services?.length > 0
                ? `<ul>${item.services
                    .map((svc) => `<li>${svc.description}</li>`)
                    .join("")}</ul>`
                : ""
            }
            <p><br/></p>
          </div>
        `;
      });
      setScopeText(data?.join("") ?? "");
    }, [pricingData]);

    return (
      <div className="summary_section">
        <div className="header">
          <div className="proposal_title">
            <div className="page_counter"> 0{index} </div>
            <h4 style={{ marginLeft: "24px" }}> Scope </h4>
          </div>
          <div className="logo_container">
            {companyLogo ? (
              <img
                src={companyLogo}
                className="temp_logo"
                alt="template logo"
              />
            ) : (
              <img
                src="/images/company/no_image_grey.png"
                className="temp_logo"
                alt="logo"
              />
            )}
          </div>
        </div>
        <div className="content">
          <ReactQuill
            modules={{
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link", "image"],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "list",
              "bullet",
              "align",
              "link",
              "image",
            ]}
            ref={quillRef}
            value={scopeText}
            onChange={setScopeText}
          />
        </div>
      </div>
    );
  }
);

export default ScopeOfWork;
